import { z } from "zod";

const passwordSchema = z
  .string()
  .min(8, "Must be at least 8 characters")
  .regex(/[A-Z]/, "Must contain at least one uppercase letter")
  .regex(/[0-9]/, "Must contain at least one number");

export const createEmployeeFormSchema = z.object({
  fullName: z.string().min(2, "Full name is required"),
  phone: z.string().min(7, "Enter a valid phone number").max(20),
  email: z.string().email("Enter a valid email address"),
  password: passwordSchema,
  designation: z.string().max(100).optional().or(z.literal("")),
});
export type CreateEmployeeFormValues = z.infer<typeof createEmployeeFormSchema>;

export const updateEmployeeFormSchema = z.object({
  fullName: z.string().min(2, "Full name is required"),
  phone: z.string().min(7, "Enter a valid phone number").max(20),
  email: z.string().email("Enter a valid email address"),
  designation: z.string().max(100).optional().or(z.literal("")),
});
export type UpdateEmployeeFormValues = z.infer<typeof updateEmployeeFormSchema>;
